import axios, { type AxiosInstance } from 'axios';

import { createMockDeployClient } from '@/shared/api/demo/mockClients';
import { REQUEST_TIMEOUT } from '@/shared/lib/constants/api';

const commonAxiosConfig = {
  timeout: REQUEST_TIMEOUT.DEFAULT,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
};

const IS_DEMO_MODE = import.meta.env.MODE === 'demo';

const realDeployApiClient = axios.create({
  ...commonAxiosConfig,
  baseURL: '/deploy',
});

realDeployApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Deploy API error:', error);
    return Promise.reject(error);
  }
);

export const deployApiClient = (IS_DEMO_MODE ? createMockDeployClient() : realDeployApiClient) as AxiosInstance;
